import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import type { ProductosResponse } from '../../../../store/MSCommerce/Productos/types';
import { DetailGallery } from './DetailGallery';
import styles from '../Productos.module.scss';

interface ProductDetailModalProps {
  product: ProductosResponse;
  onClose: () => void;
}

export const ProductDetailModal: React.FC<ProductDetailModalProps> = ({ product, onClose }) => {
  const sinStock = (product.stock ?? 0) === 0;

  return (
    <div className={styles.detail__overlay} onClick={onClose}>
      <div className={styles.detail__panel} onClick={e => e.stopPropagation()}>

        <button className={styles.detail__close} onClick={onClose}>
          <CloseOutlined />
        </button>

        {/* Izquierda: galería */}
        <div className={styles.detail__left}>
          <DetailGallery
            imagenes={product.imagenes ?? []}
            nombre={product.nombre as string}
          />
        </div>

        {/* Derecha: info */}
        <div className={styles.detail__right}>
          <p className={styles.detail__category}>{product.category}</p>
          <h2 className={styles.detail__name}>{product.nombre}</h2>

          <div className={styles.detail__priceRow}>
            <span className={styles.detail__price} style={sinStock ? { opacity: 0.5 } : {}}>
              ${product.price}
            </span>
            {sinStock ? (
              <span className={`${styles.detail__stockBadge} ${styles['detail__stockBadge--out']}`}>
                Agotado
              </span>
            ) : (
              <span className={styles.detail__stockBadge}>
                {product.stock} en stock
              </span>
            )}
          </div>

          <div className={styles.detail__divider} />

          {/* Banner agotado */}
          {sinStock && (
            <div className={styles.detail__outOfStock}>
              <span className={styles.detail__outOfStockIcon}>🚫</span>
              <div>
                <p className={styles.detail__outOfStockTitle}>Producto agotado</p>
                <p className={styles.detail__outOfStockText}>
                  Este producto no está disponible por el momento.
                </p>
              </div>
            </div>
          )}

          <div
  className={styles.detail__description}
  style={{ overflowWrap: 'normal', wordBreak: 'normal' }} // ← agrega esto
  dangerouslySetInnerHTML={{ __html: product.description ?? '' }}
/>
        </div>

      </div>
    </div>
  );
};